import { DateTime } from 'luxon';
import { SELECTED_TIME_ZONE_KEY } from '../../constants/localStorageKeys';
/** Returns a TimeZone object from a time zone value (e.g. Europe/London). */
export const getTimeZoneFromValue = (value, isDefault = false) => {
    const dateTime = DateTime.local({ locale: 'fr', zone: value });
    if (!dateTime.isValid) {
        throw Error(`Invalid time zone specified: ${dateTime.invalidReason}`);
    }
    return {
        isDefault,
        isInDST: dateTime.isInDST,
        label: value.split('/').join(' - ').split('_').join(' '),
        utcOffset: dateTime.zone.offset(DateTime.now().toMillis()),
        utcOffsetString: dateTime.zone.formatOffset(DateTime.now().toMillis(), 'short'),
        value,
    };
};
export const UTCTimeZone = getTimeZoneFromValue('Etc/UTC');
/** Returns a TimeZone object based on the browser's time. */
export const getDefaultTimeZone = () => {
    try {
        return getTimeZoneFromValue(Intl.DateTimeFormat().resolvedOptions().timeZone, true);
    }
    catch {
        return UTCTimeZone;
    }
};
/** Returns an array of TimeZone objects for time zones that are supported by the browser. */
export const getAllTimeZones = () => {
    //@ts-ignore - Not supported by our version of TypeScript. Requires 5.1.
    let list = Intl.supportedValuesOf('timeZone')
        .map((timeZone) => {
        try {
            return getTimeZoneFromValue(timeZone);
        }
        catch {
            return false; // some timezones not supported to avoid issues with storing we just filter out.
        }
    })
        .filter(Boolean);
    list = [...list, UTCTimeZone];
    return list;
};
export const storeTimeZoneValue = (value) => {
    localStorage.setItem(SELECTED_TIME_ZONE_KEY, value);
};
export const getStoredTimeZone = () => {
    const storedTimeZone = localStorage.getItem(SELECTED_TIME_ZONE_KEY);
    if (!storedTimeZone) {
        return undefined;
    }
    if (storedTimeZone[0] === '{') {
        try {
            const timeZoneObject = JSON.parse(storedTimeZone);
            const timeZoneValue = timeZoneObject.value;
            localStorage.setItem(SELECTED_TIME_ZONE_KEY, timeZoneValue);
            return getTimeZoneFromValue(timeZoneValue);
        }
        catch (error) {
            return undefined;
        }
    }
    try {
        return getTimeZoneFromValue(storedTimeZone);
    }
    catch {
        return undefined;
    }
};
